interface Props {
  value: string;
  onChange: (family: string) => void;
}

const FONTS = [
  { value: 'Noto Sans JP', label: 'Noto Sans JP', preview: 'ゴシック体' },
  { value: 'Rounded Mplus 1c', label: 'M+ Rounded', preview: '丸ゴシック' },
];

export function FontPicker({ value, onChange }: Props) {
  return (
    <div>
      <label style={{
        display: 'block',
        fontSize: '0.85rem',
        fontWeight: 'bold',
        color: 'var(--color-text-secondary)',
        marginBottom: '4px',
      }}>
        フォント
      </label>
      <div style={{ display: 'flex', gap: '8px' }}>
        {FONTS.map((f) => (
          <button
            key={f.value}
            onClick={() => onChange(f.value)}
            style={{
              flex: 1,
              padding: '8px',
              border: value === f.value ? '2px solid var(--color-primary)' : '2px solid var(--color-border)',
              borderRadius: '8px',
              background: value === f.value ? 'var(--color-surface)' : 'white',
              cursor: 'pointer',
              fontFamily: `'${f.value}', sans-serif`,
              fontSize: '0.85rem',
              textAlign: 'center',
            }}
          >
            <div style={{ fontSize: '0.75rem', color: 'var(--color-text-secondary)' }}>{f.label}</div>
            <div style={{ fontWeight: 'bold', marginTop: '2px' }}>{f.preview}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
